import { domain } from '../../Auth/Config';

export const withdrawRequestUrl = `${domain}/wp-json/freespin/v1/withdraw`;
export const withdrawCommentsListUrl = `${domain}/wp-json/freespin/v1/withdrawcomments`;
export const withdrawAPIUrl = `${domain}/wp-json/banking-page/v1/Withdrawal`;
